/* ==========================================================================
   AULBERY — product media gallery (as-product-media-gallery.js)
   Moved 1:1 out of snippets/product-media-gallery.liquid. Drives the
   segmented snap bar, thumbnail aria-current and the badge/model chip swap
   for every <media-gallery data-as-pmg>. Re-init is guarded by
   dataset.asBarInit; shopify:section:unload removes the listeners.
   ========================================================================== */
(function () {
  function asInitGallery(gallery) {
    if (!gallery || gallery.dataset.asBarInit === '1') return;
    var rail = gallery.querySelector('.product__media-list');
    var segs = gallery.querySelectorAll('.as-seg');
    if (!rail) return;
    gallery.dataset.asBarInit = '1';

    var current = -1;

    function update() {
      var slides = rail.querySelectorAll('.product__media-item');
      if (!slides.length) return;
      var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
      var w = slides[0].offsetWidth + gap;
      if (w <= 0) return;
      var i = Math.round(rail.scrollLeft / w);
      i = Math.max(0, Math.min(slides.length - 1, i));
      if (i === current) return;
      current = i;

      segs.forEach(function (s, k) {
        if (k === i) {
          s.classList.add('is-on');
        } else {
          s.classList.remove('is-on');
        }
      });

      var thumbs = gallery.querySelectorAll('.thumbnail-list .thumbnail');
      thumbs.forEach(function (t, k) {
        if (k === i) {
          t.setAttribute('aria-current', 'true');
        } else {
          t.removeAttribute('aria-current');
        }
      });

      var labelChip = gallery.querySelector('.as-chip--label');
      var modelChip = gallery.querySelector('.as-chip--model');
      var showChip = null;
      if (i === 0) {
        showChip = labelChip;
      } else {
        showChip = modelChip || labelChip;
      }
      if (labelChip) labelChip.style.display = 'none';
      if (modelChip) modelChip.style.display = 'none';
      if (showChip) showChip.style.display = 'flex';
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }
    function onResize() {
      current = -1;
      update();
    }
    rail.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onResize);
    gallery.asPmgTeardown = function () {
      rail.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      delete gallery.asPmgTeardown;
      delete gallery.dataset.asBarInit;
    };
    update();
  }

  function asInitAll() {
    document.querySelectorAll('[data-as-pmg]').forEach(asInitGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', asInitAll);
  } else {
    asInitAll();
  }
  document.addEventListener('shopify:section:load', asInitAll);
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event && event.target && event.target.querySelectorAll ? event.target : document;
    root.querySelectorAll('[data-as-pmg]').forEach(function (gallery) {
      if (typeof gallery.asPmgTeardown === 'function') gallery.asPmgTeardown();
    });
  });
})();

